export class cancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;
    this.promise = new Promise((resolve) => {
      resolvePromise = resolve;
    });

    this.promise.then((cancel) => {
      for (const listener of this.listeners) {
        listener(cancel);
      }
      this.listeners = [];
    });

    this.promise.then = (onfulfilled) => {
      let _resolve;
      const promise = new Promise((resolve) => {
        this.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = () => {
        this.unsubscribe(_resolve);
      };

      return promise;
    };

    executor((message, config, request) => {
      if (this.reason) {
        return;
      }
      this.reason = {
        name: 'canceledError',
        message: message ?? 'canceled',
        config
      };
      resolvePromise(this.reason);
    });
  }

  throwIfRequested() {
    if (this.reason) {
      Promise.reject(this.reason);
    }
  }

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }
    this.listeners.push(listener);
  }

  unsubscribe(listener) {
    const index = this.listeners.indexOf(listener);
    if (index !== -1) {
      this.listeners.splice(index, 1);
    }
  }

  toAbortSignal() {
    const controller = new AbortController();

    const abort = (error) => {
      controller.abort(error);
    };

    this.subscribe(abort);

    controller.signal.unsubscribe = () => this.unsubscribe(abort);

    return controller.signal;
  }

  static source() {
    let cancel;
    const token = new cancelToken((c) => {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}
